import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { HttpClient } from '@angular/common/http';
import { Client } from '../models/client';

@Injectable({
  providedIn: 'root',
})
export class ClientService extends CrudService<Client> {
  constructor(protected http: HttpClient) {
    super(http, 'clients');
  }
}
